import Scenario4Part1 from './Scenario4Part1';
import GameManager from '../../cvp-webgames-core/GameManager';
import { constants } from '../../misc/constants';
import BaseScenarioPart from '../../cvp-webgames-core/Scenario/BaseScenarioPart';
import { VideoEnvironmentProps } from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { CalmBaseScenario } from '../CalmBaseScenario';
import Scenario4Part2 from './Scenario4Part2';
import Scenario4Part3 from './Scenario4Part3';
import Scenario4Part4 from './Scenario4Part4';
import Scenario4Part5 from './Scenario4Part5';
import Scenario4Part6 from './Scenario4Part6';
import Scenario4Part7 from './Scenario4Part7';
import Scenario4Part8 from './Scenario4Part8';
import Scenario4Part9 from './Scenario4Part9';
import Scenario4Part10 from './Scenario4Part10';
import Scenario4Part11 from './Scenario4Part11';
import Scenario4Part12 from './Scenario4Part12';
import Scenario4Part13 from './Scenario4Part13';
import Scenario4Part14 from './Scenario4Part14';
import Scenario4Part15 from './Scenario4Part15';

export default class Scenario4 extends CalmBaseScenario {
	parts: BaseScenarioPart<CalmBaseScenario>[] = [
		new Scenario4Part1(this, () => {this.goToPart2()}),
		new Scenario4Part2(this, () => {this.goToPart3()}),
		new Scenario4Part3(this, () => {this.goToPart15()}),
		new Scenario4Part15(this, () => {this.goToPart4()}),
		new Scenario4Part4(this, () => {this.goToPart5()}),
		new Scenario4Part5(this, () => {this.goToPart6()}),		
		new Scenario4Part6(this, () => {this.goToPart7()}),
		new Scenario4Part7(this, () => {this.goToPart8()}),		
		new Scenario4Part8(this, () => {this.goToPart9()}),		
		new Scenario4Part9(this, () => {this.goToPart10()}),		
		new Scenario4Part10(this, () => {this.goToPart11()}),		
		new Scenario4Part11(this, () => {this.goToPart12()}),		
		new Scenario4Part12(this, () => {this.goToPart13()}),		
		new Scenario4Part13(this, () => {this.goToPart14()}),
		new Scenario4Part14(this, () => {this.goToScenarioEnd()})
	]
	public get totalNumberOfQuestions(): number {
		return 5;
	}

	public getEnvironmentProps(): VideoEnvironmentProps {
		return {
			controls: false,
			autoBlur: true
		};
	}

	public get currentLevel(): number {
		return 3;
    }
	
	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	public getParts(): BaseScenarioPart<CalmBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return './assets/audio/scenario4/' + fileName + '.mp3';
	}

	start() {
        this.gameManager.UiManager.createUIInstance(constants.uiNames.SplashScreenUI);
		this.goToPart1();
	}

	goToPart1() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part1.id, () => {
			this.destroyAllUIInstances();
		});
	}

	goToPart2() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part2.id);
	}

	goToPart3() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part3.id);
	}

	goToPart4() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part4.id);
	}

	goToPart5() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part5.id);
	}

	goToPart6() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part6.id);
	}

	goToPart7() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part7.id);
	}

	goToPart8() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part8.id);
	}

	goToPart9() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part9.id);
	}

	goToPart10() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part10.id);
	}

	goToPart11() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part11.id);
	}

	goToPart12() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part12.id);
	}

	goToPart13() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part13.id);
	}

	goToPart14() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part14.id);
	}

	goToPart15() {
		this.loadPart(constants.scenarios.scenario4.parts.level4Part15.id);
	}

	goToScenarioEnd() {
	}
}